import axios from "axios";

const apiCliente = axios.create({
  baseURL:  process.env.REACT_APP_API_URL,
});

apiCliente.interceptors.request.use((config) => {
  const token = localStorage.getItem("cliente_token");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

export default apiCliente;
